import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";

const FIELDS = [
  { key: "whatsapp_number", label: "WhatsApp Numarası", placeholder: "+90 5xx xxx xx xx", testid: "contact-setting-whatsapp" },
  { key: "email", label: "E-posta Adresi", placeholder: "info@hoomagency.com", testid: "contact-setting-email" },
  { key: "instagram_url", label: "Instagram Bağlantısı", placeholder: "https://www.instagram.com/...", testid: "contact-setting-instagram" },
  { key: "tiktok_url", label: "TikTok Bağlantısı", placeholder: "https://www.tiktok.com/@...", testid: "contact-setting-tiktok" },
  { key: "working_hours", label: "Çalışma Saatleri", placeholder: "Hafta içi 09:00 - 22:00", testid: "contact-setting-hours" },
];

export default function ContactSettings() {
  const [form, setForm] = useState({ whatsapp_number: "", email: "", instagram_url: "", tiktok_url: "", working_hours: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => {
      setForm({
        whatsapp_number: r.data.whatsapp_number || "",
        email: r.data.email || "",
        instagram_url: r.data.instagram_url || "",
        tiktok_url: r.data.tiktok_url || "",
        working_hours: r.data.working_hours || "",
      });
    }).catch((e) => toast.error(formatApiError(e))).finally(() => setLoading(false));
  }, []);

  const save = async () => {
    if (saving) return;
    setSaving(true);
    try {
      await api.put("/admin/settings", form);
      toast.success("İletişim bilgileri kaydedildi.");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSaving(false);
    }
  };

  const inputCls =
    "w-full bg-black/40 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder:text-[#64748B] outline-none focus:border-cyan-400/60 transition-colors";

  if (loading) return <p className="text-sm text-[#64748B]">Yükleniyor...</p>;

  return (
    <div data-testid="admin-contact-settings-page" className="max-w-2xl">
      <h1 className="font-display font-700 text-xl text-white mb-1">İletişim Bilgileri</h1>
      <p className="text-sm text-[#64748B] mb-8">Bu bilgiler ana sayfadaki iletişim bölümünde ve footer'da gösterilir</p>

      <div className="rounded-2xl border border-white/[0.06] bg-[#0A0E17] p-6 space-y-5">
        {FIELDS.map((f) => (
          <div key={f.key}>
            <label className="block text-xs font-semibold text-[#A0ABC0] mb-2">{f.label}</label>
            <input
              data-testid={f.testid}
              className={inputCls}
              placeholder={f.placeholder}
              value={form[f.key]}
              onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
            />
          </div>
        ))}
      </div>

      <button onClick={save} disabled={saving} data-testid="contact-settings-save-button" className="btn-glow mt-6 text-sm font-semibold text-white px-8 py-3.5 rounded-xl disabled:opacity-50">
        {saving ? "Kaydediliyor..." : "Bilgileri Kaydet"}
      </button>
    </div>
  );
}
